<template>
  <router-link :to="to" class="base-link">{{ text }}</router-link>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    },
    to: {
      type: [String, Object],
      required: true
    }
  },
  setup(props) {
    const themeClass = computed(() => props.theme && `base-button--${props.theme}`)

    return {
      themeClass
    }
  }

})
</script>

<style lang="scss" scoped>
.base-link {
    display: flex;
    cursor: pointer;
    color: var(--color-primary);
    text-decoration: underline;
}

.base-link:hover {
    color: var(--text-dark);
}

.base-link.router-link-active {
    color: var(--text-dark);
}

</style>
